import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { browserHistory } from 'react-router';
import { SegmentedControl } from 'segmented-control';
import ApiRequestService from '../component/ApiRequestService';
import restoreQuestionBankHandler from '../component/ArchiveRestoreAPI';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SearchBar from '../component/SearchBar';
import SecureShow from '../component/SecureShow';
import SelectBox from '../component/SelectBox';
import TableRow from '../component/TableRow';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import subcategoryStyles from '../css/subcategoryStyles.css.js';
import UserAccessDetails from '../lib/UserAccessDetails';
import ExplanationsList from './ExplanationsList';
import QuestionsList from './QuestionList';
import { AppSetting, AppProperties, ADMIN_USER_ROLE } from '../common/function';
import { CSVLink } from "react-csv";
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import CustomSegmentedControl from '../lib/components/CustomSegementedControl.js';
import ReactTooltip from 'react-tooltip';
import ColumnHeader from '../component/ColumnHeader.js';


let subcategory = {
  subcategory_name: '',
  subcategory_id: '',
  subcategory_weight: '',
  loading:false,
  subject_id:''
};

export default class Category extends Component {
  userAccessDetails = new UserAccessDetails();
  AppSetting = AppSetting();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);
    this.state = {
      subCategories: [],
      temp_subcategory: subcategory,
      //   temp_subcategory1: subcategory,

      temp_id: '',
      addMode: true,
      subCategoryDiv: true,
      questionsDiv: false,
      explanationDiv: false,
      subject_id: this.props.location.query.subject_id,
      topic_id: this.props.location.query.topic_id,
      subject_name: this.props.location.query.subject_name,
      topic_name: this.props.location.query.topic_name,
      category_name: this.props.location.query.category_name,
      category_id: this.props.location.query.category_id,
      enableSurvey:false,

      mode: 1, // 0 - SubCat, 1 - Questions, 2 - Explanations
      loading: true,
      calculationLoading: false,
      moveSubcategoryVisible : false,
      selectBoxSubjectDefaultId: parseInt(this.props.location.query.subject_id,10),
      selectBoxTopicDefaultId: parseInt(this.props.location.query.topic_id,10),
      selectBoxCategoryDefaultId:parseInt(this.props.location.query.category_id,10),
      showTopicsSelectBox: true,
      subjects: [],
      topics: [],
      moveSubcategoryId:0,
      subjectId:0,
      topicId:0,
      categoryId:0,
      categories:[],
      showCategorySelectBox:false,
      readOnly:this.props.location.query.archive_mode === 'true',
      archive_id:parseInt(this.props.location.query.archive_id,10),
      archive_mode:this.props.location.query.archive_mode,
      instructor_name: window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instSubjects:[],
      currSubject:false,
      copySubcategoryVisible: false,
      copySubcategoryId: 0,
      copySubcategoryName:"",
      countOfTCSQ:[],
      instAllSubjects:[],
      lastComputedAt: null,

      categoryExplanationCount: 0,
    };

    this.deleteSubCategory = this.deleteSubCategory.bind(this);
    this.addSubCategory = this.addSubCategory.bind(this);
    this.changeSubCategoryName = this.changeSubCategoryName.bind(this);
    this.updateSubCategory = this.updateSubCategory.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this);    
    
    this.subcategoryMoveShow = this.subcategoryMoveShow.bind(this);
    this.subcategoryMoveHide = this.subcategoryMoveHide.bind(this);

    this.selectBoxSubjectHandleChange = this.selectBoxSubjectHandleChange.bind(this);
    this.selectBoxTopicHandleChange = this.selectBoxTopicHandleChange.bind(this);
    this.selectBoxCategoryHandleChange = this.selectBoxCategoryHandleChange.bind(this);
    this.moveSubcategoryDetails = this.moveSubcategoryDetails.bind(this);

    
    this.subCategoryCopyShow = this.subCategoryCopyShow.bind(this);
    this.subCategoryCopyHide = this.subCategoryCopyHide.bind(this);
    this.copySubcategoryDetails = this.copySubcategoryDetails.bind(this);
    

    

    // this.prepareAdd = this.prepareAdd.bind(this);
    //this.errorMessageHide= this.errorMessageHide.bind(this);
  }

  /* onEnableSurveyChange = (value)=>{
    let newValue =  eval(value);
    
      this.setState({enableSurvey:newValue});
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    const payload = {
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id,
      enableSurvey:newValue
    };

    ApiRequestService({
      method: 'post',
      url: '/toggleSurveyFlag',
      data: payload
    }).then(res => {
      if(res.data !== undefined &&
        res.data.data !== undefined &&
        res.data.data)
        NotificationManager.success("Survey Flag Updated","Success",2000)
      else
      NotificationManager.error("Survey Flag Update Failed","ERROR",2000)
    }).catch(error => {
      NotificationManager.error("Survey Flag Update Failed : "+error,"ERROR",2000)
    });
    
    

  } */

  getSurveyFlag = () => {
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    const payload = {
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id
    };

    ApiRequestService({
      method: 'post',
      url: '/getCatSurveyFlag',
      data: payload
    }).then(res => {
      if(res.data !== undefined &&
        res.data.data !== undefined &&
        res.data.data.enableSurvey !== null)
        this.setState({enableSurvey:res.data.data.enableSurvey});
      else
      NotificationManager.error("Survey Flag Update Failed","ERROR",2000)
    }).catch(error => {
      NotificationManager.error("Survey Flag Update Failed : "+error,"ERROR",2000)
    });
  }
  componentWillUpdate() {
    console.debug('componentWillUpdate');
   
    this.addBreadCrumbs();
  }
  componentWillUnmount() {
    this.removeBreadCrumbs();
  }

  componentDidUpdate() {
    this._refresh();
    this.addBreadCrumbs();
  }
  
  _refresh(){
    // refresh if subject id or topic  is changed in url
    
    let paramsSubjectId = this.props.location.query.subject_id
    let paramsTopicId = this.props.location.query.topic_id
    let paramscategoryId = this.props.location.query.category_id
    if (this.state.subject_id !== paramsSubjectId  || 
        this.state.topic_id !== paramsTopicId ||
        this.state.category_id !== paramscategoryId
        ) {
      this.state.subject_id = this.props.location.query.subject_id
      this.state.subject_name = this.props.location.query.subject_name
      this.state.topic_id = this.props.location.query.topic_id
      this.state.topic_name = this.props.location.query.topic_name
      this.state.category_name = this.props.location.query.category_name
      this.state.category_id = this.props.location.query.category_id
      this.getAllSubCategoryAPI();
    }
  }


  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };


  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      {
        name: 'All Subjects',
        type: '',
        onclickPath: 'subjects'+
        '?archive_mode='+
        this.state.archive_mode+
        '&archive_id='+
        this.state.archive_id
      },
      {
        name: this.state.subject_name,
        type: 'Subjects',
        onclickPath:
          'topics?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      },
      {
        name: this.state.topic_name,
        type: 'Topics',
        onclickPath:
          'category?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name +
          '&topic_id=' +
          this.state.topic_id +
          '&topic_name=' +
          this.state.topic_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      },
      {
        //topic_id=1&subject_id=6&category_id=1&subject_name=Froyo&topic_name=XBOX&category_name=Motrola
        name: this.state.category_name,
        type: 'Categories',
        onclickPath:
          'subCategory?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name +
          '&topic_id=' +
          this.state.topic_id +
          '&topic_name=' +
          this.state.topic_name +
          '&category_id=' +
          this.state.category_id +
          '&category_name=' +
          this.state.category_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      }
    ]);
  };

  createSelectItems() {
    let items = [];
    for (let i = 1; i <= 10; i++) {
      items.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return items;
  }

  componentWillMount() {
    this.getAllSubCategoryAPI();
  }

  getAllSubCategoryAPI = () => {
    this.setState({ loading: true });
     //this.getInstSubjectData();

      
    
    // Commenting out Survey Radio since it is not being used 
    //this.getSurveyFlag();
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    let payload = {
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id,
    };

    if(this.state.archive_mode === 'true'){
      payload['archive_id'] = this.state.archive_id;
      payload['archive_mode'] = true;
    }
    console.debug('Topic id : ', payload);

    let instSubjectPromise = this.userAccessDetails.getSubjectsByInstructor();
    instSubjectPromise.then(subjectsByIns => {   
      let currSubject = false
      if(subjectsByIns !== null){
        if(subjectsByIns[sub_id]===true){
          currSubject= true
        } 
      }   
      
    ApiRequestService({
      method: 'post',
      url: '/getAllSubCategories',
      data: payload
    }).then(res => {
      console.debug(
        'Get All Categories res :',
        res.data.data.subCategory_names
      );

      if (res && res.data && res.data.data?.category_explanation_count) {
        this.setState({
          categoryExplanationCount: res.data.data?.category_explanation_count,
        })
      }

      if (res.data.data.subCategory_names !== null) {
        let subCategory_namesList =res.data.data.subCategory_names;
        let enableSurveyList =res.data.data.enableSurvey;
       
          this.setState({
            subCategories: subCategory_namesList,
            enableSurvey:enableSurveyList,
            instSubjects :subjectsByIns,
            currSubject:currSubject,
            loading: false,
            lastComputedAt: res.data.data.last_computed_at?.includes("1970") ? null : res.data.data.last_computed_at,
          });
          }else{
            this.setState({
              instSubjects :subjectsByIns,
              currSubject:currSubject,
              loading: false,
              lastComputedAt: null,
            });
          }
        })
      console.debug('Subcat data set: ', this.state.subCategories);
    }).catch(err =>{
      this.setState({ loading: false });
      this.hide();
      NotificationManager.error(err, 'ERROR', 3000);
    });

    this.loadSubjectData();    
    this.loadTopicData(this.state.selectBoxSubjectDefaultId);  
    this.loadCategory(this.state.selectBoxSubjectDefaultId, this.state.selectBoxTopicDefaultId);
    this.getCountOfTCSQ();
  }

 
  getCountOfTCSQ = () => {
    console.debug("In count tcsq")
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    const payload = {
      subject_id : sub_id,
      topic_id : top_id ,
      category_id : cat_id,
      subcategory_id : 0 
    }

    ApiRequestService({
      method: 'post',
      url: '/getCountOfTCSQ',
      data: payload
    }).then(res => {
      if(res.data !== undefined && res.data !== null && res.data.data.CountOfTCSQ !== undefined && res.data.data.CountOfTCSQ !== null){
        console.debug(res);
        console.debug('getCountOfTCSQ State: ');
        this.setState({
          countOfTCSQ : res.data.data.CountOfTCSQ
        });
      }
    });
  }
  addSubCategory() {
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    if (
      this.state.temp_subcategory.subcategory_name === null ||
      this.state.temp_subcategory.subcategory_name.trim() === ''
    ) {
      alert('Please enter a valid "Subcategory name"');
      return;
    }
    this.setState({ loading: true });
    console.debug('Add subcategory :' + this.state.temp_subcategory);
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    console.debug(
      'Add subcategory weight:' + this.state.temp_subcategory.subcategory_weight
    );
    // var subcat_weight = parseInt(
    //   this.state.temp_subcategory.subcategory_weight,
    //   10
    // );
    const payload = {
      subcategory_name: this.state.temp_subcategory.subcategory_name.trim(),
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id,
      //subcategory_weight: subcat_weight
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/addSubCategory',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      if (res.data.message !== null && res.data.message !== '') {
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.hide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }

      if (res.data.data !== null) {
        this.state.subCategories.push({
          subcategory_name: res.data.data.subcategory_name,
          subcategory_id: res.data.data.subcategory_id,
          subcategory_weight: res.data.data.subcategory_weight,
          subject_id:sub_id
        });
        this.state.countOfTCSQ.push({
          number_of_subcategories:0,
          number_of_questions:0
        })
        if (res.data.data.subCategory_names !== null) {
          this.setState({
            subCategories: this.state.subCategories,
            countOfTCSQ:this.state.countOfTCSQ
          });
        }
      }
      this.getCountOfTCSQ();
      this.setState({ loading: false });
      this.hide();
    });
    
  }
  // errorMessageHide(){
  //     console.debug("errorType");
  //     var tempErrortype = "";
  //     var tempErrorMessage = "";
  //     this.setState({
  //         errorMessage: tempErrortype,
  //         errorType:tempErrortype,
  //     })

  // }
  onDropdownSelected = e => {
    console.debug('THE Dropdown Selected VAL : ', e.target.value);
    // alert(this.state.temp_subcategory);
    let tempSubcategory = this.state.temp_subcategory;
    tempSubcategory.subcategory_weight = e.target.value;

    this.setState({
      temp_subcategory: tempSubcategory
    });
    console.debug('THE Dropdown Selected VAL : ', this.state.temp_subcategory);
  };

  editSubCategory(id) {
    this.setState({
      temp_subcategory: this.state.subCategories[id],
      temp_id: id,
      addMode: false
    });
    this.show(false);
  }

  updateSubCategory() {
    this.setState({ loading: true });
    console.debug(
      'Editing subcategory :' + this.state.temp_subcategory.subcategory_id
    );
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    // var subcat_weight = parseInt(
    //   this.state.temp_subcategory.subcategory_weight,
    //   10
    // );
    // this.state.temp_subcategory
    const payload = {
      subcategory_name: this.state.temp_subcategory.subcategory_name,
      subcategory_id: this.state.temp_subcategory.subcategory_id,
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      //subcategory_weight: subcat_weight
    };
    console.debug('Update SubCategory Payload : ', payload);
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/updateSubCategory',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug('UpdateCategory Response :', res);
      let tempSubCategories = this.state.subCategories;
      tempSubCategories[this.state.temp_id] = payload;
      this.setState({
        subCategories: tempSubCategories,
        loading: false
      });
      this.hide();
      this.setState({
        addMode: true
      });
    });
  }
  deleteSubCategory(id) {
    this.setState({ loading: true });
    console.debug(
      'Deleting subcategory i:' +
        id +
        ' id: ' +
        this.state.subCategories[id].subcategory_id
    );
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    const payload = {
      subcategory_id: this.state.subCategories[id].subcategory_id,
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id,
      archive_mode:this.state.archive_mode
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/deleteSubCategory',
      data: payload
    })
      .then(res => {
        this.setState({
          loading:false
        });
        console.debug(res);
        //window.localtion.reload();
        this.state.subCategories.splice(id, 1);
        console.debug('Spliced Array', this.state.subCategories);
        this.state.countOfTCSQ.splice(id, 1);
        this.setState({
          countOfTCSQ:this.state.countOfTCSQ,
          subCategories: this.state.subCategories,
          loading: false
        });
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete subcategory',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  changeSubCategoryName(e) {
    let tempSubcategory = this.state.temp_subcategory;
    tempSubcategory.subcategory_name = e;
    tempSubcategory.subcategory_weight = 1;

    this.setState({ temp_subcategory: tempSubcategory });
  }
  tabOnChange(e) {
    console.debug(e);
    if (e === 'Questions') {
      this.setState({
        subCategoryDiv: false,
        questionsDiv: true,
        explanationDiv: false,
        mode: 0
      });
    } else if (e === 'SubCategory') {
      this.setState({
        subCategoryDiv: true,
        questionsDiv: false,
        explanationDiv: false,
        mode: 1
      });
    } else if (e === 'Explanation') {
      this.setState({
        subCategoryDiv: false,
        questionsDiv: false,
        explanationDiv: true,
        mode: 2
      });
    }
  }

  show = isEnableSubcategory => {
    //this.errorMessageHide();
    if (isEnableSubcategory) {
      this.setState({
        temp_subcategory: {
          subcategory_name: '',
          subcategory_id: '',
          subcategory_weight: ''
        }
      });
    }
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  subjPage() {
    browserHistory.push(this.baseFolder + 'subjects');
  }
  topcPage = () => {
    browserHistory.push(
      this.baseFolder +
        'topics?subject_id=' +
        this.state.subject_id +
        '&subject_name=' +
        this.state.subject_name
    );
  };
  catgPage = () => {
    browserHistory.push(
      this.baseFolder +
        'category?subject_id=' +
        this.state.subject_id +
        '&subject_name=' +
        this.state.subject_name +
        '&topic_id=' +
        this.state.topic_id +
        '&topic_name=' +
        this.state.topic_name
    );
  };
  delete = id => {
    confirmAlert({
      title: 'Are you sure want to delete this SubCategory?',
      message: 'Press Confirm to submit',

      cancelLabel: 'Confirm',
      confirmLabel: 'Cancel',
      onCancel: () => this.deleteSubCategory(id)
    });
  };
  //   onDropdownSelected(e) {
  //     //alert("THE Dropdown Selected VAL : ", e.target.value);
  //     console.debug("THE Dropdown Selected VAL : ", e.target.value);

  // }

  loadSubjectData() {
    //let answerIndex = 0;
    ApiRequestService({
      method: 'post',
      url: '/getAllSubjects'
    }).then(res => {
      //console.debug(res.data.data.subject_names);
      if(res !== undefined && res !== null &&
        res.data !== undefined && res.data !== null && 
        res.data.data !== undefined && res.data.data !== null &&
        res.data.data.subject_names !== undefined && res.data.data.subject_names !== null  ){

          this.setState({
            subjects: res.data.data.subject_names
          });
         
          console.debug("res.data.data.subject_names",res.data.data.subject_names);
          
          let tempInstSubjects = JSON.parse(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`))
    
          tempInstSubjects && tempInstSubjects.subjectsbyInstructor && Object.keys(tempInstSubjects.subjectsbyInstructor).forEach((tempSubjectId)=>{
            this.state.subjects.forEach((subject)=>{
              if(subject.subject_id === parseInt(tempSubjectId)){
                this.state.instAllSubjects.push(subject)
              }
            })
          })
        }
      
    });
    
  }

  
  loadTopicData(sub_id) {
    //console.debug("loadTopicData");
    this.setState({ subjectId: sub_id });
    var tempTopic = [];
    const payload = {
      // subject_id: this.state.subject_id
      subject_id: sub_id
    };
    //console.debug("Subject id : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllTopics',
      data: payload
    }).then(res => {
      console.debug('topic res=', res.data.data.topic_names);

      if (res.data.data.topic_names !== null) {
        tempTopic = res.data.data.topic_names;
        this.setState({
          topics: tempTopic,
          showTopicsSelectBox: true
        });
        //this.selectBoxTopicHandleChange(this.createFakeEvent(tempTopic[0].topic_id));
      } else {
        this.setState({
          topics: []
        });
        // this.selectBoxTopicHandleChange(this.createFakeEvent(-1));
      }
    });
    
  }

  loadCategory(sub_id, top_id) {
    this.setState({ topicId: top_id });
    const payload = {
      topic_id: top_id,
      subject_id: sub_id
    };
    //console.debug("Topic id : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllCategories',
      data: payload
    }).then(res => {
      console.debug('Get All Categories res :', res.data.data.category_names);
      if (res.data.data.category_names !== null) {
        this.setState({
          categories: res.data.data.category_names,
          showCategorySelectBox: true
        });

        //this.selectBoxCategoryHandleChange(this.createFakeEvent(res.data.data.category_names[0].category_id));
      } else {
        this.setState({
          categories: []
        });
        // this.selectBoxCategoryHandleChange(this.createFakeEvent(-1));
      }
    });
  }
  subcategoryMoveShow(subcategoryId) {
    //this.errorMessageHide();
    var tempMoveSubcategoryId = parseInt(subcategoryId, 10);
    this.setState({ moveSubcategoryVisible: true,
      moveSubcategoryId: tempMoveSubcategoryId });
  };

  subcategoryMoveHide () {

    this.setState({
      moveSubcategoryVisible: false,
      
    });
  };


  selectBoxSubjectHandleChange(event) {
    // console.debug( "selectBoxSubjectHandleChange =",event.target.value);
    //this.setState({selectBoxTopicValue: event.target.value});

    var sub_id = parseInt(event.target.value, 10);
    this.setState({
      subjectId: sub_id,
      showTopicsSelectBox: false,
      selectBoxTopicDefaultId: 0,
      selectBoxCategoryDefaultId: 0
    });

    this.loadTopicData(sub_id);
  }
  
  selectBoxTopicHandleChange(event) {
    console.debug('selectBoxTopicHandleChange =', event.target.value);
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(event.target.value, 10);
    this.setState({
      showCategorySelectBox: false,
      showSubCategorySelectBox: false,
      topicId:top_id,
      selectBoxCategoryDefaultId: 0
    });
    
   this.loadCategory(sub_id, top_id);
  }

  selectBoxCategoryHandleChange(event) {
    //console.debug( "selectBoxCategoryHandleChange =",event.target.value);


    var cat_id = parseInt(event.target.value, 10);
    this.setState({      
      categoryId:cat_id
    });
    //this.loadSubcategory(sub_id, top_id, cat_id);
  }

  moveSubcategoryDetails(){
    
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(this.state.topicId, 10);
    var cat_id = parseInt(this.state.categoryId, 10);
    var moveSubcategoryId =  parseInt(this.state.moveSubcategoryId, 10);
    var previousSubjectId = parseInt(this.props.location.query.subject_id, 10);
    var previousTopicId = parseInt(this.props.location.query.topic_id, 10);
    var previousCategoryId = parseInt(this.props.location.query.category_id, 10);
    
    const payload = {
      
      topic_id: top_id,
      subject_id: sub_id,
      category_id:cat_id,
      subcategory_id:moveSubcategoryId,
      previous_topic_id:previousTopicId,
      previous_subject_id:previousSubjectId,
      previous_category_id:previousCategoryId,
      move_subcategory_mode:true,    // Moving a subcategory to another category will be true.
      is_copying: true,
    };
    this.setState({ loading: true });
     console.log("Move subCategories request : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/moveSubcategory',
      data: payload
    }).then(res => {
      console.debug('Move subCategories res :', res);
      if(res !== undefined && res !== null &&
        res.data !== undefined && res.data !== null  &&
        res.data.message !== undefined && res.data.message !== null 
        && res.data.message !== "" ){
        NotificationManager.error(res.data.message, 'ERROR', 3000);  
      }else{
        NotificationManager.success("Moved Successfully","SUCCESS",5000);
      }
      this.setState({ loading: false }, ()=>{
        this.subcategoryMoveHide();  
        this.getAllSubCategoryAPI();
        //this.catgPage();   
      });
    });
  
  }

  copySubcategoryDetails(){
    
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(this.state.topicId, 10);
    var cat_id = parseInt(this.state.categoryId, 10);
    var previousSubjectId = parseInt(this.props.location.query.subject_id, 10);
    var previousTopicId = parseInt(this.props.location.query.topic_id, 10);
    var previousCategoryId = parseInt(this.props.location.query.category_id, 10);
    var previousSubcategoryId =  parseInt(this.state.copySubcategoryId, 10);
    
    const payload = {
      
      topic_id: top_id,
      subject_id: sub_id,
      category_id:cat_id,
      previous_topic_id:previousTopicId,
      previous_subject_id:previousSubjectId,
      previous_category_id:previousCategoryId,
      previous_subcategory_id:previousSubcategoryId,
      subcategory_name:this.state.copySubcategoryName,
      is_copying: true,
    };
    console.log("copy subcategory payload is : ",payload)
    this.setState({ loading: true });
     console.log("Move subCategories request : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/copySubCategory',
      data: payload
    }).then(res => {
      console.debug('Move subCategories res :', res);
      if(res !== undefined && res !== null &&
        res.data !== undefined && res.data !== null  &&
        res.data.message !== undefined && res.data.message !== null 
        && res.data.message !== "" ){
        NotificationManager.error(res.data.message, 'ERROR', 3000);  
      }else{
        NotificationManager.success("SubCategory copied successfully.")
        this.getAllSubCategoryAPI();
        
      }
      this.setState({ loading: false });
      this.subCategoryCopyHide();  
      //this.catgPage();   
        
    });
  
  }

  subCategoryCopyShow(subcategoryId,subcategoryName) {
    //this.errorMessageHide();
    var tempCopySubcategoryId = parseInt(subcategoryId, 10);
    var catID = parseInt(this.state.category_id, 10)
    this.setState({ 
      copySubcategoryVisible: true,
      copySubcategoryId: tempCopySubcategoryId,
      copySubcategoryName:subcategoryName,
      categoryId: catID,
    });
  };

  subCategoryCopyHide () {
    this.setState({
     copySubcategoryVisible: false,
          
    });
  };

  changeCopySubCategoryName = (e) => {
    let tempCopySubcategoryName = e;
    this.setState({ copySubcategoryName: tempCopySubcategoryName });
  }
  

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
        this.addSubCategory()
      }else{
        this.updateSubCategory();
      }
    }
  }

  calculateAccuracyAndTime = () => {

    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    var cat_id = parseInt(this.state.category_id, 10);
    
    let payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      type: "Subcategory"
    }
    this.setState({ calculationLoading: true });
    ApiRequestService({
      method: 'post',
      url: '/calculateAccuracyAndTime',
      data: payload
    }).then(res => {
        if (res && res.data && res.data.status === 0) {
          let accuracyTimeArr = res.data.data.accuracy_time_arr ? res.data.data.accuracy_time_arr : [];
          console.debug("this.state.subCategories>>", this.state.subCategories)
          let updatedSubcategories = this.state.subCategories.map(subcategory => {
            let accuracyTimeData = accuracyTimeArr.find(acc => {
              return acc.subject_id === subcategory.subject_id &&
              acc.topic_id === subcategory.topic_id &&
              acc.category_id === subcategory.category_id &&
              acc.subcategory_id === subcategory.subcategory_id
            })
            if (accuracyTimeData) {
              return {
                ...subcategory,
                avg_time: accuracyTimeData.time,
                difficulty_level: accuracyTimeData.accuracy
              }
            }
            return subcategory;
          });
          console.debug("updatedSubcategories>>>", updatedSubcategories)
          this.setState({
            subCategories: updatedSubcategories,
            lastComputedAt: new Date(),
          })

          NotificationManager.success("Calculation of accuracy and time completed successfully!", "", 3000);
        } else {
          NotificationManager.error("Something went wrong", "", 3000);
        }
      }).finally(() => {
        this.setState({ calculationLoading: false });
      });
  }


  render() {
    let button = null;
    if (this.state.addMode) {
      button = (
        <Button style={styles.addButton} onClick={this.addSubCategory}>
          Add SubCategory
        </Button>
      );
    } else {
      button = (
        <Button style={styles.addButton} onClick={this.updateSubCategory}>
          Update SubCategory
        </Button>
      );
    }
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    var moveModifyButton = (
      <Button style={styles.addButton} onClick={this.moveSubcategoryDetails}>
        Move
      </Button>
    );
    var moveCancelButton = (
      <Button style={styles.cancelButton} onClick={this.subcategoryMoveHide}>
        Cancel
      </Button>
    );
    const moveActions = [];
    moveActions.push(moveModifyButton);
    moveActions.push(moveCancelButton);

    const copyActions = [];
    var copyButton = (
      <Button style={styles.addButton} onClick={this.copySubcategoryDetails}>
        Copy
      </Button>
    );
    var copyCancelButton = (
      <Button style={styles.cancelButton} onClick={this.subCategoryCopyHide}>
        Cancel
      </Button>
    );
    copyActions.push(copyButton);
    copyActions.push(copyCancelButton);

    var tbody;
    if (this.state.subCategories !== null) {
      console.debug('Subcat data set1: ', this.state.subCategories);
      tbody = (
        <tbody>
          {this.state.subCategories.map((subcategory, i) => (
            <TableRow
              key={subcategory.subcategory_id}
              // {...alert(subcategory.subCategory_name,subcategory.subCategory_id)}
              data={subcategory}
              pushId={'subcategory'}
              id={subcategory.subcategory_id}
              name={subcategory.subcategory_name}
              title={'Categories'}
              type={'subcategory'}
              weight={subcategory.subcategory_weight}
              difficulty_level={subcategory.difficulty_level}
              avg_time={subcategory.avg_time}
              url={
                'SubCategoryDetails?topic_id=' +
                this.state.topic_id +
                '&subject_id=' +
                this.state.subject_id +
                '&category_id=' +
                this.state.category_id +
                '&subject_name=' +
                this.state.subject_name +
                '&topic_name=' +
                this.state.topic_name +
                '&category_name=' +
                this.state.category_name +
                '&subcategory_id=' +
                subcategory.subcategory_id +
                '&subcategory_name=' +
                subcategory.subcategory_name+
                '&archive_mode='+
                this.state.archive_mode+
                '&archive_id='+
                this.state.archive_id
              }
              onChange={() => this.onDropdownSelected}
              onEditClick={() => this.editSubCategory(i)}
              onDeleteClick={() => this.delete(i)}
              onMoveSubcategoryClick={() => this.subcategoryMoveShow(subcategory.subcategory_id)}
              show_archive_actions={this.state.archive_mode}
              instructorSubject={(this.state.instSubjects && this.state.instSubjects[subcategory.subject_id] === true) }
              onArchiveRestoreClick={()=>this.onArchiveRestoreClick(subcategory)}
              onCopyClick={()=>this.subCategoryCopyShow(subcategory.subcategory_id,subcategory.subcategory_name)}
              countOfTCSQ={this.state.countOfTCSQ !== undefined && this.state.countOfTCSQ !== null ? this.state.countOfTCSQ[i] : null}
            />
          ))}
        </tbody>
      );
    }

    return (
      (this.state.loading)?
        <div   style={{ marginTop:"-261px"}}  >
          <LoadingSpinner loading={this.state.loading} />
        </div>
      :
      <SecureShow targetRole={1}>
        <div className="subCategoryContainer" style={{ marginTop:"120px"}} >

          <div style={styles.subcategorySegemntStyle} className="ToggleButtonDiv" >
            {/* <SegmentedControl className="segmentedControlClass"
              name="oneDisabled"
              options={[
                { label: 'SubCategories', value: 'SubCategory', default: true },
                { label: 'Questions', value: 'Questions' },
                { label: 'Explanations', value: 'Explanation' }
              ]}
              setValue={newValue => this.tabOnChange(newValue)}
              style={styles.SegmentedControlCatDetails} //
            /> */}
          </div>

          <div style={styles.catTitle}>
            Category Details - {this.state.category_name}
            {
                this.state.readOnly
              ?
                null
              : <div style={this.state.currSubject ?  styles.floatRight : {display:"none"} }>
                {this.state.mode === 1  && (!this.appProperties.enableLTI) ? (
                  <div style={{display:'flex', gap:'8px'}}>
                    <Button 
                    style={{
                      display: this.state.userprofilerole === ADMIN_USER_ROLE ? 'block' : 'none'
                    }}
                    primary flat onClick={this.calculateAccuracyAndTime}
                        tooltipLabel={
                          <div>{this.state.lastComputedAt ? 
                            `Last computed at: ${moment(this.state.lastComputedAt).format('DD/MM/YYYY hh:mm a')}` : "N/A"}
                          </div>
                        }
                        disabled={this.state.calculationLoading}>
                          {this.state.calculationLoading ? <span>
                            <BeatLoader color={'#bb0000'} loading={true} size={10} />
                          </span> : "Calculate accuracy and time"}
                        </Button>
                 <Button className="archive-button" primary raised
                style={{float: "right"}}
                  onClick={() => this.show(true)}>
                    Add a New Sub Category
                  </Button> 
                  </div>
                ) : (
                  ''
                )}
              </div> 
            }
            <div>
            <div style={{
                  width:'400px',
                  marginTop:'16px'
                }}>
                  <CustomSegmentedControl
                      options={[
                        { label: 'SubCategories', value: 'SubCategory', default: true },
                        { label: (
                          <div>
                            <ReactTooltip  effect='solid' id='explanation' type='light' className='tool-tip'>
                              <span>
                              {this.state.categoryExplanationCount === 0 ? "No explanations for this category" :
                                `View explanations for this category`
                              }
                              </span>
                            </ReactTooltip>
                            <div data-tip data-for='explanation'>Explanations ({this.state.categoryExplanationCount})</div>
                        </div>
                        ), value: 'Explanation' }
                      ]}
                      setValue={(newValue )=> this.tabOnChange(newValue)}
                      style={styles.categorySegmentedControl}
                    />
                </div>

            <DialogContainer
                  id="simple-action-dialog"
                  visible={this.state.moveSubcategoryVisible}
                  onHide={this.subcategoryMoveHide}
                  actions={moveActions}
                  title="Move Subcategory"
                  width="700px"
                >
                {/*(this.state.loading) ?
                    <LoadingSpinner loading={true} />
                  : ""*/}
                <table className="tableStyle">
                  <tr>
                <td>
                  <SelectBox
                        labeltxt="Subjects"
                        columns={this.state.userprofilerole === 2 ?this.state.subjects:
                          this.state.instAllSubjects}
                        keys={['subject_id', 'subject_name']}
                        className="create-question-select-box"
                        selectBoxcallBack={this.selectBoxSubjectHandleChange}
                        defaultId={this.state.selectBoxSubjectDefaultId}
                        //selectBoxDisabled={controlEnable}
                      />
                </td>
                
                <td>
                  
                <SelectBox
                //<label>Topics {this.state.selectBoxTopicDefaultId}</label>
                      labeltxt="Topics"
                      columns={this.state.topics}
                      keys={['topic_id', 'topic_name']}
                      className="create-question-select-box"
                      selectBoxcallBack={this.selectBoxTopicHandleChange}
                      defaultId={this.state.selectBoxTopicDefaultId}
                      //selectBoxDisabled={controlEnable}
                      ///bug-tracker#156
                      style={{
                        visibility: this.state.showTopicsSelectBox
                          ? 'visible'
                          : 'hidden'
                      }}
                    />
                    </td>
                <td>
                <SelectBox
                      labeltxt="categories"
                      columns={this.state.categories}
                      keys={['category_id', 'category_name']}
                      className="create-question-select-box"
                      selectBoxcallBack={this.selectBoxCategoryHandleChange}
                      defaultId={this.state.selectBoxCategoryDefaultId}
                      ///bug-tracker#156
                      style={{
                        visibility: this.state.showCategorySelectBox
                          ? 'visible'
                          : 'hidden'
                      }}
                  
                    />
                    </td>
                    </tr>
                    </table>
            </DialogContainer>
          </div>
          <div>

            <DialogContainer
                  id="simple-action-dialog"
                  visible={this.state.copySubcategoryVisible}
                  onHide={this.subCategoryCopyHide}
                  actions={copyActions}
                  title="Copy SubCategory"
                  width="700px"
                >
                {/*(this.state.loading) ?
                    <LoadingSpinner loading={true} />
                  : ""*/}
                  <div>Name{' '}
                    <TextField
                    id="subcatId"
                      type="text"
                      name="catagory_name"
                      value={
                        this.state.copySubcategoryName || ''
                      }
                      onChange={this.changeCopySubCategoryName}
                      style={subcategoryStyles.dialogText}
                      //onKeyPress={this.isEnterPressed.bind(this)}              
                    />
                  </div><br/>
                  <table>

                  <tr>
                    <td>
                      <SelectBox
                            labeltxt="Subjects"
                            columns={this.state.userprofilerole === 2 ?this.state.subjects:
                              this.state.instAllSubjects}
                            keys={['subject_id', 'subject_name']}
                            className="create-question-select-box"
                            selectBoxcallBack={this.selectBoxSubjectHandleChange}
                            defaultId={this.state.selectBoxSubjectDefaultId}
                            //selectBoxDisabled={controlEnable}
                          />
                    </td>
                
                    <td>
                      
                    <SelectBox
                    //<label>Topics {this.state.selectBoxTopicDefaultId}</label>
                          labeltxt="Topics"
                          columns={this.state.topics}
                          keys={['topic_id', 'topic_name']}
                          className="create-question-select-box"
                          selectBoxcallBack={this.selectBoxTopicHandleChange}
                          defaultId={this.state.selectBoxTopicDefaultId}
                          //selectBoxDisabled={controlEnable}
                          ///bug-tracker#156
                          style={{
                            visibility: this.state.showTopicsSelectBox
                              ? 'visible'
                              : 'hidden'
                          }}
                        />
                        </td>
                    <td>
                    <SelectBox
                          labeltxt="categories"
                          columns={this.state.categories}
                          keys={['category_id', 'category_name']}
                          className="create-question-select-box"
                          selectBoxcallBack={this.selectBoxCategoryHandleChange}
                          defaultId={this.state.selectBoxCategoryDefaultId}
                          ///bug-tracker#156
                          style={{
                            visibility: this.state.showCategorySelectBox
                              ? 'visible'
                              : 'hidden'
                          }}
                      
                        />
                      </td>
                    </tr>
                  </table>
            </DialogContainer>
          </div>
            {/*
              Commenting out Survey Radio since it is not being used 
            <div style={styles.floatRight}>
            {this.state.mode === 1 ? (
              <SelectionControlGroup
              style={styles.floatRight}
                id="radioEnableSurvey"
                name="radioEnableSurvey"
                type="radio"
                label="Enable Survey"
                value={this.state.enableSurvey}
                controls={[
                  {
                    label: 'Yes',
                    value: true
                  },
                  {
                    label: 'No',
                    value: false
                  }
                ]}
                onChange={this.onEnableSurveyChange}
                className="radioButtonAlign"
              />):''}
            </div>
            */}
          </div>
          {this.state.mode === 0 ? (
            <QuestionsList 
              subject_id={this.state.subject_id}
              topic_id={this.state.topic_id}
              category_id={this.state.category_id}
              archive_id={this.state.archive_id}
              archive_mode={this.state.archive_mode}
              readOnly={this.state.readOnly}
              plusButton={this.state.questionsDiv}
              location={this.props.location}
              // subcategory_id = {this.state.subcategory_id}
            />
          ) : (
            ''
          )}
          {this.state.mode === 2 ? (
            <ExplanationsList
              subject_id={this.state.subject_id}
              topic_id={this.state.topic_id}
              category_id={this.state.category_id}
              loading={this.state.loading}
              subcategory_id = {0}
              archive_id={this.state.archive_id}
              archive_mode={this.state.archive_mode}
              readOnly={this.state.readOnly}
              updateTotalCount={(updatedCount) => {
                this.setState({
                  categoryExplanationCount: updatedCount,
                })
              }}
            />
          ) : (
            ''
          )}

          <div style={{float:'right', marginRight:'1rem', marginTop:"6px",}}>
            <CSVLink data={[
              ['ID', 'Name', '# of Questions', 'Accuracy', 'Time'],
              ...this.state.subCategories?.map(subCat => {

                let count =  this.state.countOfTCSQ.find(ele => (
                  `${ele.subject_id}_${ele.topic_id}_${ele.category_id}_${ele.subcategory_id}` === `${subCat.subject_id}_${subCat.topic_id}_${subCat.category_id}_${subCat.subcategory_id}`
                ));

                return [
                  subCat.subcategory_id,
                  subCat.subcategory_name,
                  count ? count.number_of_questions : 0,
                  subCat.difficulty_level,
                  subCat.avg_time,
                ]
              })
            ]}  target='_blank' enclosingCharacter='"' filename={`Subcategories list for ${this.state.category_name} from ${this.state.topic_name}.csv`}>
                <Button flat primary iconChildren="cloud_download">Download CSV</Button>
            </CSVLink>
          </div>

          {this.state.mode === 1 ? (
            <div id="subCategoryTab">
              <DialogContainer
                id="simple-action-dialog"
                visible={this.state.visible}
                onHide={this.hide}
                actions={actions}
                //title="SubCategory"
                width="500px"
              >
              <p style={{fontSize:"medium"}}><b><label for="subcatId">New SubCategory</label></b></p>
                Name{' '}
                <TextField
                id="subcatId"
                  type="text"
                  name="catagory_name"
                  value={
                    this.state.temp_subcategory.subcategory_name || ''
                  }
                  onChange={this.changeSubCategoryName}
                  style={subcategoryStyles.dialogText}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                />
                <br />
                <br />
                {/* Weight{' '}
                <select
                  onChange={this.onDropdownSelected}
                  defaultValue={
                    this.state.temp_subcategory.subcategory_weight || 0
                  }
                > 
                  {this.createSelectItems()}
                </select>*/}
              </DialogContainer>
              <table style={styles.catTable} className="tableClassStyle">
                <thead style={styles.thead}>
                  <tr>
                    <th>ID</th>
                    <th style={{textAlign:'left',paddingLeft:'25px'}}>SubCategory</th>
                    {/* <th colSpan="2">Total Number Of </th> */}
                    <th>Questions</th>
                    <th>Explanations</th>
                    <th><ColumnHeader title={"Accuracy"} tooltip={"Mean Accuracy"} /></th>
                    <th><ColumnHeader title={"Time"} tooltip={"Median Time per question in seconds"} /></th>
                    {/* <th>Weight</th> */}
                    {
                        this.state.readOnly ||  this.appProperties.enableLTI  ?
                        null:
                        <th>Actions</th>
                    }
                  </tr>
                </thead>
                  {/* <tr>
                    <th></th>
                    <th></th>
                    <th>Questions</th>
                    <th>Explanations</th>
                    <th></th>
                  </tr> */}
                {tbody}
              </table>
              <br/>
              <center>
                {
                  !this.appProperties.enableLTI  ? 
                  <div style={this.state.currSubject  ? {display:"none"}:{width:"35%"}}className='image-resize-warning'>
                  <p><b>Note :</b> Contact Administrator to gain access to edit this page.</p>
                  </div> : " "
                }
              {
                this.appProperties.enableLTI  ? 
                <div style={{width:"35%",marginTop:"10px"}} className='image-resize-warning'>
                <p><b>Note :</b> No one can make any changes in the LTI version. Please go to the OSU core question bank to make changes</p>
                </div> : " "
              }
              </center>
            </div>
          ) : (
            ''
          )}
        </div>
      </SecureShow>
    );
  }

  //Archive Restore
  onArchiveRestoreClick = (object) => {
    let payload = {
      subject_id:object.subject_id,
      topic_id:object.topic_id,
      category_id:object.category_id,
      subcategory_id:object.subcategory_id
    };
    restoreQuestionBankHandler(payload);
  }
}
